import React, { useState } from "react";
import { Grid, GridColumn as Column, GridNoRecords } from "@progress/kendo-react-grid";
import styles from "../../components/VatReturn/VatReturn.module.scss";
import { AmountFormat, DateFormat } from "components/common/formatter";
import { RedirectCell, GRID_PAGE_SIZES } from "components/common/GridComponents.jsx";
import { GridLoader } from "components/GridLoader";
import { SALES_TAB_BOXES, getVatReturnBox, VAT_BOX_CALCULATION_FIELDS } from "./vatReturnBoxes";
import { BoxRowComponent } from "components/VatReturn";

const SalesTab = ({ calculations, salesTransactions, loading, onViewPosting }) => {
  const [dataState, setDataState] = useState({
    take: 50,
    skip: 0,
    pageable: { pageSizes: GRID_PAGE_SIZES },
  });

  const transactions = salesTransactions ?? [];

  const pagedData = transactions.slice(dataState.skip, dataState.skip + dataState.take);

  const DateCell = ({ dataItem }) => (
    <td>{dataItem.date ? DateFormat(dataItem.date) : ""}</td>
  );

  const AmountCell = ({ dataItem, field }) => (
    <td className="text-end">{AmountFormat(dataItem[field] ?? 0)}</td>
  );

  const Redirect = (props) => (
    <RedirectCell handleClick={() => onViewPosting && onViewPosting(props.dataItem)} />
  );

  return (
    <div className={`container-fluid ${styles['tab-container']}`}>
      <div className="row mt-3 mb-2 flex-shrink-0">
        <div className="col-12">
          {SALES_TAB_BOXES.map((box, i) => (
            <BoxRowComponent
              index={i}
              key={box}
              box={box}
              label={getVatReturnBox(box)?.details}
              amount={calculations?.[VAT_BOX_CALCULATION_FIELDS[box]]}
            />
          ))}
        </div>
      </div>

      <Grid
        data={pagedData}
        skip={dataState.skip}
        take={dataState.take}
        total={transactions.length}
        pageable={dataState.pageable}
        onPageChange={(e) =>
          setDataState((prev) => ({ ...prev, skip: e.page.skip, take: e.page.take }))
        }
        loader={
          <GridLoader />
        }
        showLoader={loading}
        className={`fs-md flex-grow-1 overflow-auto ${pagedData.length > 0 ? 'mb-5' : ''}`}
      >
        <GridNoRecords>
          {loading ? <span /> : "No records available"}
        </GridNoRecords>
        <Column field="date" title="Date" width={120} cell={DateCell} />
        <Column field="postingTypeString" title="Type" width={80} />
        <Column field="matterRef" title="Ref" width={120} />
        <Column field="details" title="Details" />
        <Column
          field="vatAmount"
          title="VAT"
          width={120}
          cell={(props) => <AmountCell dataItem={props.dataItem} field="vatAmount" />}
          headerClassName="text-end"
        />
        <Column
          field="netAmount"
          title="Net"
          width={120}
          cell={(props) => <AmountCell dataItem={props.dataItem} field="netAmount" />}
          headerClassName="text-end"
        />
        <Column width="60px" cell={Redirect} />
      </Grid>
    </div>
  );
};

export default SalesTab;
